module.exports = __webpack_public_path__ + "img/microservicesStructure.b18ddba0.png";